// source: pbtypes/gen/skills/ui_radio_group.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_skills_ui_radio_option_pb = require('../../../pbtypes/gen/skills/ui_radio_option_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_ui_radio_option_pb);
var pbtypes_gen_skills_ui_radio_style_pb = require('../../../pbtypes/gen/skills/ui_radio_style_pb.js');
goog.object.extend(proto, pbtypes_gen_skills_ui_radio_style_pb);
goog.exportSymbol('proto.skills.UiRadioGroup', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.UiRadioGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.skills.UiRadioGroup.repeatedFields_, null);
};
goog.inherits(proto.skills.UiRadioGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.UiRadioGroup.displayName = 'proto.skills.UiRadioGroup';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.skills.UiRadioGroup.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.UiRadioGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.UiRadioGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.UiRadioGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiRadioGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
label: jspb.Message.getFieldWithDefault(msg, 2, ""),
detail: jspb.Message.getFieldWithDefault(msg, 3, ""),
optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    pbtypes_gen_skills_ui_radio_option_pb.UiRadioOption.toObject, includeInstance),
selectedOption: jspb.Message.getFieldWithDefault(msg, 5, 0),
style: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.UiRadioGroup}
 */
proto.skills.UiRadioGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.UiRadioGroup;
  return proto.skills.UiRadioGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.UiRadioGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.UiRadioGroup}
 */
proto.skills.UiRadioGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setDetail(value);
      break;
    case 4:
      var value = new pbtypes_gen_skills_ui_radio_option_pb.UiRadioOption;
      reader.readMessage(value,pbtypes_gen_skills_ui_radio_option_pb.UiRadioOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSelectedOption(value);
      break;
    case 6:
      var value = /** @type {!proto.skills.UiRadioStyle.Enum} */ (reader.readEnum());
      msg.setStyle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.UiRadioGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.UiRadioGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.UiRadioGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.UiRadioGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      pbtypes_gen_skills_ui_radio_option_pb.UiRadioOption.serializeBinaryToWriter
    );
  }
  f = message.getSelectedOption();
  if (f !== 0) {
    writer.writeSint32(
      5,
      f
    );
  }
  f = message.getStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.skills.UiRadioGroup.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiRadioGroup} returns this
 */
proto.skills.UiRadioGroup.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.skills.UiRadioGroup.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiRadioGroup} returns this
 */
proto.skills.UiRadioGroup.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string detail = 3;
 * @return {string}
 */
proto.skills.UiRadioGroup.prototype.getDetail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.skills.UiRadioGroup} returns this
 */
proto.skills.UiRadioGroup.prototype.setDetail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated UiRadioOption options = 4;
 * @return {!Array<!proto.skills.UiRadioOption>}
 */
proto.skills.UiRadioGroup.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.skills.UiRadioOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_skills_ui_radio_option_pb.UiRadioOption, 4));
};


/**
 * @param {!Array<!proto.skills.UiRadioOption>} value
 * @return {!proto.skills.UiRadioGroup} returns this
*/
proto.skills.UiRadioGroup.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.skills.UiRadioOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.skills.UiRadioOption}
 */
proto.skills.UiRadioGroup.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.skills.UiRadioOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.skills.UiRadioGroup} returns this
 */
proto.skills.UiRadioGroup.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};


/**
 * optional sint32 selected_option = 5;
 * @return {number}
 */
proto.skills.UiRadioGroup.prototype.getSelectedOption = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.UiRadioGroup} returns this
 */
proto.skills.UiRadioGroup.prototype.setSelectedOption = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional UiRadioStyle.Enum style = 6;
 * @return {!proto.skills.UiRadioStyle.Enum}
 */
proto.skills.UiRadioGroup.prototype.getStyle = function() {
  return /** @type {!proto.skills.UiRadioStyle.Enum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.skills.UiRadioStyle.Enum} value
 * @return {!proto.skills.UiRadioGroup} returns this
 */
proto.skills.UiRadioGroup.prototype.setStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


goog.object.extend(exports, proto.skills);
